const defaultGroups = [];

export default defaultGroups;
